import request from '@/utils/request'


// 首页项目详情列表
export function projectInfo(query) {
  return request({
    url: '/project/projectInfo/'+query,
    method: 'get',
  })
}
// 首页项目展示列表
export function projectlist(query) {
  return request({
    url: '/project/projectListByType/'+query,
    method: 'get'
  })
}
// 收入排行榜
export function Topgrossinglist() {
  return request({
    url: '/grossing/list/',
    method: 'get'
  })
}
// 项目广场查询条件数据
export function ProjectType() {
  return request({
    url: '/projectSquare/queryCondition/',
    method: 'get'
  })
}
//项目广场查询条件数据
export function projectSquareQuery(data) {
  return request({
    url: '/projectSquare/query',
    method: 'post',
    data: data
  })
}
// 选择身份
export function Selectthe(data) {
  return request({
    url: '/website/'+data,
    method: 'put',
    data: data
  })
}
// 选择身份获取token
export function obtaintoken() {
  return request({
    url: '/website/account/getNewToken',
    method: 'get'
  })
}
// 任务列表查询条件
export function Thetasklist(dictType) {
  return request({
    url: '/data/type/'+dictType,
    method: 'get'
  })
}
// 任务列表表格
export function Taskform(data) {
  return request({
    url: '/projectlist',
    method: 'post',
    data: data
  })
}
// 任务列表表格报名
export function Taskregistration(pakeId) {
  return request({
    url: '/projectlist/'+pakeId,
    method: 'get'
  })
}

// 整包报名接口
export function getApplyProject(pakeId) {
  return request({
    url: '/projectlist/applyProject/'+pakeId,
    method: 'get'
  })
}


// 保证金信息查询
export function Margininformation(pakeId) {
  return request({
    url: '/projectlist/apply/'+pakeId,
    method: 'get'
  })
}
// 前台接包方报名缴纳保证金
export function Depositpaymentpassword(data) {
  return request({
    url: '/projectlist/payDeposit',
    method: 'post',
    data:data
  })
}
// 个人中心接包方修改登录密码
export function ChangingtheLoginPassword(data) {
  return request({
    url: '/website/updatePassWord',
    method: 'post',
    data:data
  })
}
// 项目广场项目列表附件下载
export function Downloadattachment(adnId) {
  return request({
    url: '/attachment/zipDownload/'+adnId,
    method: 'get'
  })
}
// 首页轮播图接口
export function Typesofidentity(identity) {
  return request({
    url: '/website/IdentityCheck/'+identity,
    method: 'get'
  })
}

// 前台首页-查询所有的banner图
export function bannerlist(identity) {
  return request({
    url: '/banner/list'+identity,
    method: 'get'
  })
}


// 退出登录时候调的接口
export function Logoutanmin() {
  return request({
    url: '/website/logout',
    method: 'delete'
  })
}
// 获取用户头像
export function Accesstoimage() {
  return request({
    url: '/userInfo/headportrait',
    method: 'get'
  })
}
// 获取二维码地址
export function GetQRcode() {
  return request({
    url: '/wx/getQRCode',
    method: 'get'
  })
}
// 首页总数接口

export function showNumber() {
  return request({
    url: '/home/showNumber',
    method: 'get'
  })
}
// 首页列表数据
export function packageListHomepage(tayp) {
  return request({
    url: '/home/packageList/' + tayp,
    method: 'get'
  })
}

// 查询所有的推广组织
export function getorganization(tayp) {
  return request({
    url: '/organization/list?type=' + tayp,
    method: 'get'
  })
}

// 绑定微信  获取二维码地址
export function getBindQRCode() {
  return request({
    url: '/wx/getBindQRCode',
    method: 'get'
  })
}

// 选择身份时调用的接口
export function setSelectType(tayp) {
  return request({
    url: '/website/selectType/' + tayp,
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/projectSquare/xmgc.js